export default __webpack_public_path__ + "static/media/h1-1.fd5366e0.jpg";